import { CartState } from '../types';

const state: CartState = {
  carts: [],
  viewedCartId: '',
};

export default state;
